import React, { Component } from "react";
class Nav extends Component {
  state = {
    visible: false,
    menuFlag: false,
    select_index: 0,
  };
  componentDidMount() {
    if (this.props.navIndex) {
      this.setState({
        select_index: this.props.navIndex,
      });
    }
    this.props.componentRef(this, "nav");
  }

  // 打开菜单列表
  openMenuList = () => {
    console.log(111)
    const menuFlag = this.state.menuFlag;
    this.setState({
      menuFlag: !menuFlag,
    });
  };
  //   跳转页面
  toPage(e, index) {
    if (index !== 2) {
      this.setState({
        menuFlag: false,
      });
      this.props.toPage(index);
    }
  }
  //点击logo
  toLogoClick(e) {
    this.props.logoClick();
  }
  //   跳转页面
  toSecondPage(e, page) {
    this.setState({
      menuFlag: false,
    });
    this.props.toSecondPage(page);
  }
  render() {
    const navList = ["首页", "公司简介", "产品&服务", "媒体之声", "联系我们"];
    const { menuFlag, select_index } = this.state;
    const navListShow = this.props.navListShow;
    let flag = false
    if(navListShow){
      flag = menuFlag
    }else {
      flag = false
    }
    return (
      <div>
        <div className="nav-top">
          <img
            className="nav-top-left"
            src={require("@/assets/images/mobile-images/logo.png").default}
            alt=""
          />
          <img
            className="nav-top-right"
            src={require("@/assets/images/mobile-images/menu.png").default}
            alt=""
            onClick={this.openMenuList}
          />
        </div>
        <div className={`nav-bottom ${flag ? "navShow" : ""}`}>
          {navList.map((val, index) => (
            <div
              className={`nav-list ${index === 2 ? "nav-level" : ""} ${
                select_index === index ? "nav_selected" : ""
              }`}
              key={index}
            >
              <div onClick={(e) => this.toPage(e, index)}>{val}</div>
              {index === 2 ? (
                <div className="nav-level-container">
                  <div onClick={(e) => this.toSecondPage(e, "CBU")}>
                    连接服务
                  </div>
                  <div onClick={(e) => this.toSecondPage(e, "EBU")}>
                    生态服务
                  </div>
                </div>
              ) : null}
            </div>
          ))}
        </div>
      </div>
    );
  }
}
export default Nav;
